import { ClientFileErrorHandler } from '@tribeplatform/gql-client/lib'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

/**
 * Shows a red notification like error message
 * @param message Second line (description) of the toast message
 */
export const composerError = (message: string) => {
  toast({
    title: 'Error',
    description: message,
    status: 'error',
  })
}

/**
 * File upload error handler
 * @param error Error object with fileName property
 */
export const fileUploadError: ClientFileErrorHandler = error => {
  toast({
    title: `Unable to upload ${error?.fileName || ''}`,
    description: error?.message,
    status: 'error',
  })
}
